var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Preview"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.profile),
      expression: "resume.profile"
    }],
    attrs: {
      "data-name": "profile"
    }
  }, [_c('h1', [_vm._v("\n      " + _vm._s(_vm.resume.profile.name) + "\n    ")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.resume.profile.title))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.resume.profile.city))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.resume.profile.birthday))])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.education),
      expression: "resume.education"
    }],
    attrs: {
      "data-name": "projects"
    }
  }, [_c('h2', [_vm._v("项目经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.projects), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    attrs: {
      "data-name": "workHistory"
    }
  }, [_c('h2', [_vm._v("工作经历")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.workHistory), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.company))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.education),
      expression: "resume.education"
    }],
    attrs: {
      "data-name": "education"
    }
  }, [_c('h2', [_vm._v("毕业院校")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.education), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.school) + "\n          "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" - " + _vm._s(item.content) + " ")])])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.awards),
      expression: "resume.awards"
    }],
    attrs: {
      "data-name": "awards"
    }
  }, [_c('h2', [_vm._v("获奖情况")]), _vm._v(" "), _c('ol', _vm._l((_vm.resume.awards), function(item) {
    return _c('li', [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resume.contacts),
      expression: "resume.contacts"
    }],
    attrs: {
      "data-name": "contacts"
    }
  }, [_c('h2', [_vm._v("联系方式")]), _vm._v(" "), _c('table', _vm._l((_vm.resume.contacts), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.contact))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.content),
        expression: "item.content"
      }]
    }, [_vm._v(" " + _vm._s(item.content) + " ")])])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd85e64e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = j5go
// module chunks = 1